export { TrustpilotWidget } from './trustpilot-widget';
export type { TrustpilotWidgetProps } from './trustpilot-widget';
